import { render, staticRenderFns } from "./NationalityStep.vue?vue&type=template&id=0b70f2f8"
import script from "./NationalityStep.vue?vue&type=script&lang=js"
export * from "./NationalityStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports